import AddGraphModal from './Modals/AddGraphModal';
import { Box, Tab, Tabs, IconButton, Tooltip } from '@mui/material';
import '../../scss/Graph/Graph.scss';
import ChartComponent from './Subcomponents/ChartComponent';
import DeleteChartModal from './Modals/DeleteDeviceModal';
import AddDashboardModal from './Modals/AddDashboardModal';
import NotInformation from '../../components/NotInformation';
import DeleteDashboardModal from './Modals/DeleteDashboardModal';
import { permissionObj } from '../../Helpers/permission';
import ButtonAction from './../../components/buttons/ButtonAction';
import HeadTittle from '../../components/HeadTittle';
import { chartComponents, templates } from './Model/Templates';
import { AddIcon, TrashOutlineIcon } from '../../components/buttons/IconButtons';
import GraphPanelFunctionality from './Functionality/GraphPanelFunctionality';
import { CustomTextField } from '../../components/CustomTextField';
const GraphsPanel = () => {
    const {
        DEV,
        permission,
        handleCreateClick,
        handleRemoveDashboard,
        hasDashboards,
        tabIndex,
        setTabIndex,
        tabLabels,
        editingTab,
        newTabName,
        setNewTabName,
        handleTabLabelSave,
        t,
        handleTabLabelChange,
        graphData,
        containerRef,
        sectionsByTab,
        charts,
        handleDragOver,
        handleDrop,
        handleDragStart,
        handleRemoveChart,
        handleSectionClick,
        modalShow,
        setModalShow,
        changed,
        setChanged,
        userId,
        modalShowAddDashboard,
        setModalShowAddDashboard,
        dashboardIdSection,
        showDeleteChartModal,
        setShowDeleteChartModal,
        selectedChartId,
        deletedFlag,
        setDeletedFlag,
        dashboardToDelete,
        sectionPosition,
        showDeleteDashboardModal,
        setShowDeleteDashboardModal,
    } = GraphPanelFunctionality();

    return (
        <>
            <Box className='w-100'>
                <Box>
                    <div className='charts-option-container'>
                        <HeadTittle name={'graph'}>
                            {(DEV || permission?.includes(permissionObj?.WEB_CHART_CREATE)) && (
                                <ButtonAction
                                    id='btn_gp_createDashboard'
                                    name='create'
                                    className='btn-icon-add'
                                    onClick={handleCreateClick}
                                    Icon={AddIcon}
                                    splitName={false}
                                />
                            )}
                            {(DEV || permission?.includes(permissionObj?.WEB_CHART_DELETE)) && (
                                <ButtonAction
                                    id='btn_gp_deleteDashboard'
                                    name='delete'
                                    className='btn-icon-delete'
                                    onClick={handleRemoveDashboard}
                                    Icon={TrashOutlineIcon}
                                    splitName={true}
                                    disabled={!hasDashboards}
                                />
                            )}
                        </HeadTittle>
                        {hasDashboards ? (
                            <Tabs
                                variant='scrollable'
                                scrollButtons='auto'
                                value={tabIndex}
                                onChange={(event, newValue) => setTabIndex(newValue)}
                                aria-label='tabs'
                                className='margin-top-20'
                            >
                                {Object.keys(tabLabels).map((index) => (
                                    <Tab
                                        className='margin-top-27'
                                        key={index}
                                        label={
                                            editingTab === Number(index) ? (
                                                <CustomTextField
                                                    value={newTabName}
                                                    onChange={(e) => setNewTabName(e.target.value)}
                                                    onBlur={() => handleTabLabelSave(Number(index))}
                                                    autoFocus
                                                    id='txt_gp_name'
                                                    type='text'
                                                    placeholder={t('click_outside_to_save')}
                                                />
                                            ) : (
                                                <div className='margin-top-28'>
                                                    {(DEV || permission?.includes(permissionObj?.WEB_CHART_DELETE)) && (
                                                        <Tooltip title={t('delete_dashboard')}>
                                                            <IconButton
                                                                size='small'
                                                                id='btn_gp_deleteDashboard'
                                                            ></IconButton>
                                                        </Tooltip>
                                                    )}
                                                    {tabLabels[index].toLocaleUpperCase()}
                                                    {(DEV || permission?.includes(permissionObj?.WEB_CHART_UPDATE)) && (
                                                        <Tooltip title={t('edit_tab_name')}>
                                                            <IconButton
                                                                size='small'
                                                                id='btn_gp_editTabName'
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleTabLabelChange(Number(index));
                                                                }}
                                                            >
                                                                <i
                                                                    className='fa fa-pencil dark-green fs-5 ms-2'
                                                                    aria-hidden='true'
                                                                />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </div>
                                            )
                                        }
                                    />
                                ))}
                            </Tabs>
                        ) : null}

                        {graphData.length === 0 ? (
                            <NotInformation text={t('no_information')} card={true} />
                        ) : (
                            <div className='container-g' ref={containerRef}>
                                {sectionsByTab[tabIndex]?.map((section, index) => {
                                    const chartData =
                                        charts[tabIndex] && charts[tabIndex][index]
                                            ? charts[tabIndex][index].data
                                            : null;
                                    const chartType =
                                        charts[tabIndex] && charts[tabIndex][index]
                                            ? charts[tabIndex][index].component
                                            : 'bar';
                                    const position =
                                        charts[tabIndex] && charts[tabIndex][index]
                                            ? charts[tabIndex][index].data.position
                                            : index;
                                    const label =
                                        chartData && chartData.datasets && chartData.datasets.length > 0
                                            ? chartData.datasets[0].label
                                            : 'No Label';

                                    return (
                                        <div
                                            key={section}
                                            className={section}
                                            onDragOver={handleDragOver}
                                            onDrop={(e) => handleDrop(e, section, index)}
                                        >
                                            <div
                                                className={`content-${section.charAt(section.length - 1)}`}
                                                draggable={DEV || permission?.includes(permissionObj?.WEB_CHART_UPDATE)}
                                                onDragStart={(e) => {
                                                    if (DEV || permission?.includes(permissionObj?.WEB_CHART_UPDATE)) {
                                                        handleDragStart(e, chartData.id, index);
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            >
                                                {chartData ? (
                                                    <>
                                                        {(DEV ||
                                                            permission?.includes(permissionObj?.WEB_CHART_DELETE)) && (
                                                            <Tooltip title={t('delete')}>
                                                                <IconButton
                                                                    id='btn_gp_deleteChart'
                                                                    className='position-absolute-top-right'
                                                                    onClick={() => handleRemoveChart(chartData.id)}
                                                                >
                                                                    <TrashOutlineIcon className='icon-w ' />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}
                                                        <ChartComponent
                                                            data={chartData}
                                                            label={t(chartData.label)}
                                                            typo={chartType}
                                                        />
                                                    </>
                                                ) : (
                                                    (DEV || permission?.includes(permissionObj?.WEB_CHART_CREATE)) && (
                                                        <div
                                                            className='add-graphic-message'
                                                            onClick={() => {
                                                                const dashboardId = graphData[tabIndex]?.id;
                                                                handleSectionClick(section, dashboardId);
                                                            }}
                                                            id='btn_gp_addChart'
                                                        >
                                                            <div>{t('click_to_create_chart').toUpperCase()}</div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </Box>
            </Box>

            {modalShow && (
                <AddGraphModal
                    show={modalShow}
                    chartComponents={chartComponents}
                    sectionPosition={sectionPosition}
                    dashboardIdSection={dashboardIdSection}
                    onHide={() => setModalShow(false)}
                    changed={changed}
                    setChanged={setChanged}
                    userId={userId}
                />
            )}
            {modalShowAddDashboard && (
                <AddDashboardModal
                    show={modalShowAddDashboard}
                    onHide={() => setModalShowAddDashboard(false)}
                    templates={templates}
                    userId={userId}
                    dashboardId={dashboardIdSection}
                    graphData={graphData}
                    changed={changed}
                    setChanged={setChanged}
                />
            )}
            {showDeleteChartModal && (
                <DeleteChartModal
                    show={showDeleteChartModal}
                    onHide={() => setShowDeleteChartModal(false)}
                    chartId={selectedChartId}
                    changed={changed}
                    setChanged={setChanged}
                    flag={deletedFlag}
                    onDelete={() => setDeletedFlag(true)}
                    userId={userId}
                />
            )}
            {showDeleteDashboardModal && (
                <DeleteDashboardModal
                    show={showDeleteDashboardModal}
                    onHide={() => setShowDeleteDashboardModal(false)}
                    changed={changed}
                    setChanged={setChanged}
                    dashboardId={dashboardToDelete}
                    userId={userId}
                />
            )}
        </>
    );
};

export default GraphsPanel;
